import React, { useState } from 'react';

const PORTS = ['Alger','Bejaia','Oran','Annaba','Djendjen','Skikda','Mostaganem','Ghazaouet'];
const SPECIALTIES = ['Alimentaire','Équipements industriels','Matières premières','Pharmaceutique','Textile','Chimique','Électronique','Véhicules','Construction','Autre'];
const WILAYAS = ['Alger','Oran','Bejaia','Annaba','Constantine','Sétif','Blida','Tizi Ouzou','Tlemcen','Mostaganem','Jijel','Skikda','Autre'];

export default function ForwarderRegistration({ lang }) {
  const ar = lang === 'ar';
  const L = (fr, a) => ar ? a : fr;
  const [submitted, setSubmitted] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [sending, setSending] = useState(false);
  const [form, setForm] = useState({
    companyName: '', contactName: '', email: '', phone: '', wilaya: '',
    ports: [], dgdLicense: '', specialties: [], countries: '',
  });

  const toggleArray = (arr, val) => arr.includes(val) ? arr.filter(v => v !== val) : [...arr, val];

  if (submitted) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: '2rem', maxWidth: 500, margin: '2rem auto' }}>
        <div style={{ fontSize: '2.5rem', marginBottom: '0.5rem' }}>✅</div>
        <h3 style={{ color: '#10b981' }}>{L('Compte créé !', 'تم إنشاء الحساب!')}</h3>
        <p style={{ color: 'var(--muted)', fontSize: '0.85rem' }}>
          {L('Vérifiez votre email pour confirmer, puis connectez-vous sur l\'espace transitaire.', 'تحقق من بريدك لتأكيد التسجيل، ثم سجل الدخول في فضاء وكيل الجمارك.')}
        </p>
        <a href="/transitaire/dashboard" className="btn btn-primary" style={{ marginTop: '1rem', width:'auto' }}>{L('Se connecter →', 'تسجيل الدخول →')}</a>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.companyName || !form.email || !form.phone) { setError(L('Remplissez tous les champs obligatoires.','املأ جميع الحقول الإلزامية.')); return; }
    if (!password || password.length < 6) { setError(L('Mot de passe : 6 caractères minimum.','كلمة المرور: 6 أحرف على الأقل.')); return; }

    setSending(true);
    try {
      const { supabase, db } = await import('../../lib/supabase');

      // 1. Create Supabase Auth account
      const { error: authErr } = await supabase.auth.signUp({ email: form.email, password });
      if (authErr) { setError(authErr.message); setSending(false); return; }

      // 2. Save forwarder profile
      const { error: dbErr } = await db.from('freight_forwarders').insert({
        company_name: form.companyName, contact_name: form.contactName,
        email: form.email, phone: form.phone, wilaya: form.wilaya,
        ports_covered: form.ports, dgd_license: form.dgdLicense,
        product_specialties: form.specialties,
      });
      if (dbErr) console.error('DB error:', dbErr);

      setSending(false);
      setSubmitted(true);
    } catch (err) { setError(err.message); setSending(false); }
  };

  return (
    <div style={{ maxWidth: 600, margin: '2rem auto', padding: '0 1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <a href="/" style={{ fontSize: '0.85rem', color: '#6366f1', textDecoration: 'none' }}>← {L('Retour à TidjarAI', 'العودة إلى TidjarAI')}</a>
      </div>
      <div className="card">
        <div className="card-title">🏢 {L('Inscription Transitaire', 'تسجيل وكيل الجمارك')}</div>
        <p style={{ fontSize: '0.8rem', color: 'var(--muted)', marginBottom: '1rem' }}>
          {L(
            'Inscrivez-vous pour recevoir des demandes de devis d\'importateurs qualifiés.',
            'سجل لتلقي طلبات عروض أسعار من مستوردين مؤهلين.'
          )}
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group"><label>{L('Raison sociale', 'التسمية الاجتماعية')} *</label><input value={form.companyName} onChange={e => setForm({ ...form, companyName: e.target.value })} required /></div>
          <div className="form-group"><label>{L('Nom du responsable', 'اسم المسؤول')} *</label><input value={form.contactName} onChange={e => setForm({ ...form, contactName: e.target.value })} required /></div>
          <div className="form-row">
            <div className="form-group"><label>Email *</label><input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
            <div className="form-group"><label>{L('Mot de passe', 'كلمة المرور')} *</label><input type="password" value={password} onChange={e => setPassword(e.target.value)} required minLength={6} placeholder={L('6 caractères minimum','6 أحرف على الأقل')} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>{L('Téléphone', 'الهاتف')} *</label><input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} required /></div>
            <div className="form-group"><label>{L('Wilaya', 'الولاية')}</label>
              <select value={form.wilaya} onChange={e => setForm({ ...form, wilaya: e.target.value })}>
                <option value="">{L('— Sélectionner —', '— اختر —')}</option>
                {WILAYAS.map(w => <option key={w} value={w}>{w}</option>)}
              </select>
            </div>
            <div className="form-group"><label>{L('N° agrément DGD', 'رقم اعتماد المديرية العامة للجمارك')}</label><input value={form.dgdLicense} onChange={e => setForm({ ...form, dgdLicense: e.target.value })} /></div>
          </div>

          <div className="form-group">
            <label>{L('Ports couverts', 'الموانئ المغطاة')}</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
              {PORTS.map(p => (
                <button key={p} type="button" onClick={() => setForm({ ...form, ports: toggleArray(form.ports, p) })}
                  style={{ padding: '0.3rem 0.6rem', borderRadius: 8, border: '1px solid', borderColor: form.ports.includes(p) ? '#6366f1' : '#e5e7eb', background: form.ports.includes(p) ? '#eef2ff' : 'white', color: form.ports.includes(p) ? '#6366f1' : '#6b7280', fontSize: '0.78rem', cursor: 'pointer' }}>
                  {p}
                </button>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label>{L('Spécialités produits', 'تخصصات المنتجات')}</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
              {SPECIALTIES.map(s => (
                <button key={s} type="button" onClick={() => setForm({ ...form, specialties: toggleArray(form.specialties, s) })}
                  style={{ padding: '0.3rem 0.6rem', borderRadius: 8, border: '1px solid', borderColor: form.specialties.includes(s) ? '#10b981' : '#e5e7eb', background: form.specialties.includes(s) ? '#ecfdf5' : 'white', color: form.specialties.includes(s) ? '#10b981' : '#6b7280', fontSize: '0.78rem', cursor: 'pointer' }}>
                  {s}
                </button>
              ))}
            </div>
          </div>

          {error && <div className="alert alert-danger" style={{ fontSize:'0.8rem', marginBottom:'0.5rem' }}>⚠️ {error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={sending}>
            {sending ? <><span className="spinner"/> {L('Création...','جاري الإنشاء...')}</> : `🏢 ${L('Créer mon compte','إنشاء حسابي')}`}
          </button>
        </form>
      </div>
    </div>
  );
}
